import React from 'react';
import { compose, lifecycle } from 'recompose';
import { Link } from 'react-router';
import { connectUserHeaderinfo } from '../../Auth/WithUserHeaderInfo';
import { withStoreDetail } from '../../Common/Providers/WithStoreDetail';
import { withUserSubscriptionsData } from '../../Common/Providers/SubscriptionApi';
import SubscriptionLogo from '../../Common/SubscriptionLogo';
import HTMLTrans from '../../Common/Translations/HTMLTrans';

const PlanDetail = (props) => {
  const {
    subscription: {
      label,
      description,
      price,
      period,
      expiryDate,
      remainingShippingCredit,
    },
    symbol,
    shippingBenefit,
    shippingCreditEnabled,
    globalShippingCreditEnabled
  } = props;

  return (
    <div className='container-fluid p-0'>
      <div className='row pb-2'>
        <div className='col'>
          <div className='d-flex flex-wrap align-items-center'>
            <span className="dashboard__subscription-logo-container">
              <SubscriptionLogo height={55}/>
            </span>
            <div dangerouslySetInnerHTML={{ __html: label }}></div>
          </div>
        </div>
      </div>
      <div className='row pb-3'>
        <div className='col'>
          <HTMLTrans id="account.photobookpass_expireson">Expires on</HTMLTrans>
        </div>
        <div className='col-8'>
          : {expiryDate}
        </div>
      </div>
      <hr className='subscriptionSeperator'/>
      <div className='row pb-3'>
        <div className='col'>
        <HTMLTrans id="account.photobookpass_fee">Fee</HTMLTrans>
        </div>
        <div className='col-8'>
          : {symbol}{price} {period.label}<br/>
        </div>
      </div>
      {!globalShippingCreditEnabled && shippingCreditEnabled && <div className='row pb-3'>
        <div className='col'>
          <HTMLTrans id="account.photobookpass_shippingcreditremaining">Shipping Credits Remaining</HTMLTrans>
        </div>
        <div className='col-8'>
          : {symbol}{remainingShippingCredit}
        </div>
      </div>
      }
      {!shippingCreditEnabled && <div className='row pb-3'>
        <div className='col'>
          <HTMLTrans id="account.photobookpass_freeshippingremaining">Free Shipping Remaining</HTMLTrans>
        </div>
        <div className='col-8'>
          : {(!shippingBenefit.isUnlimited) ? shippingBenefit.remaining : 'Unlimited'} ({shippingBenefit.name})
        </div>
      </div>
      }
      <div className='row pb-3'>
        <div className='col'>
          <HTMLTrans id="account.photobookpass_allyearbenefit">All-Year Benefits</HTMLTrans>
        </div>
        <div className='col-8'>
          :
        </div>
      </div>
      <div className='row pb-3'>
        <div className='col'>
          <div className='subscription__desc' dangerouslySetInnerHTML={{ __html: description }}></div>
        </div>
      </div>

    </div>
  );
};

const PlanInfo = (props) => {
  const {
    store: {
      currency: {
        symbol = '',
      },
    },
    subscriptions = [],
    shippingCreditEnabled,
    globalShippingCreditEnabled
  } = props;

  const subscription = subscriptions[0];
  const getShippingBenefit = () => {
    let result = [];
    subscription.benefits.forEach((benefit) => {
      if (benefit.type.toLowerCase().indexOf('shipping') !== -1) {
        result = benefit;
      }
    });
    return result;
  }

  return (
    !!subscription && <div>
      {subscription.canUpdateDob &&
        <div className='bg-primary-lighten-2 rounded p-3'>
          <Link to={'/account/dashboard/personal'}>Update your birth date</Link> to receive exclusive birthday deals.
        </div>
      }
      <div className='col-xl-12 no-gutter'>
        <div className='container my-3 p-0'>
          <p>You are currently subscribed to</p>
          <PlanDetail
            subscription={subscription}
            symbol={symbol}
            shippingBenefit={getShippingBenefit()}
            shippingCreditEnabled={shippingCreditEnabled}
            globalShippingCreditEnabled={globalShippingCreditEnabled}
          />
        </div>
      </div>
      {
        subscription.name === 'all-access' && <p className="text-gray-lighten-1">
          <em>Need help contact our dedicated email for All-Access Subscriber at&nbsp;
            <a href="mailto:pass@photobookworldwide.com"
               target="_top">pass@photobookworldwide.com</a>
          </em>
        </p>
      }
    </div>
  );
}

const enhance = compose(
  connectUserHeaderinfo,
  withStoreDetail,
  withUserSubscriptionsData,
  lifecycle({
    componentDidMount() {
      if(this.props.shouldCallApi) {
        this.props.handleShown();
        this.didCallApi = true;
      } else {
        this.didCallApi = false;
      }
    },
    componentDidUpdate() {
      if(this.props.shouldCallApi && !this.didCallApi) {
        this.didCallApi = true;
        this.props.handleShown();
      }
    },
  })
)
export default enhance(PlanInfo);
export const undecorated = PlanInfo;



// WEBPACK FOOTER //
// ./src/Account/Subscription/PlanInfo.js